import http from "./http"
import cookie from "./cookie"
import {
  LoginDTO,
  User,
  CreateUserDTO,
  GenericUpdateDTO,
  DeleteUserDTO,
  UserTokenResponse,
  UserResponse,
} from "../models/user"
import { Pagination, QueryParams } from "../models/misc"
import HelperService from "./helper"

class UserService {
  private readonly baseUrl = "/user"

  async readUsers(filters?: QueryParams) {
    const queryString = HelperService.buildSearchQueryString(filters)
    const { data } = await http.get<Pagination<User>>(`${this.baseUrl}${queryString}`)
    return data
  }

  async readUser(id: string) {
    const { data } = await http.get<UserResponse>(`${this.baseUrl}/${id}`)
    return data
  }

  async readUserByUsername(username: string) {
    const { data } = await http.get<UserResponse>(`${this.baseUrl}/username/${username}`)
    return data
  }

  async createUser(dto: CreateUserDTO) {
    const { data } = await http.post<UserTokenResponse>(`${this.baseUrl}/`, dto)
    cookie.setCookie("token", data.token)
    return data
  }

  async genericUpdate(dto: GenericUpdateDTO) {
    const { data } = await http.put<UserResponse>(`${this.baseUrl}/${dto.id}`, dto)
    return data
  }

  async login(dto: LoginDTO) {
    const { data } = await http.post<UserTokenResponse>(`${this.baseUrl}/login`, dto)
    cookie.setCookie("token", data.token)
    return data
  }

  async checkToken() {
    const { data } = await http.get<UserTokenResponse>(`${this.baseUrl}/login/token`)
    cookie.setCookie("token", data.token)
    return data
  }

  logout() {
    cookie.removeCookie("token")
  }

  async deleteUser(dto: DeleteUserDTO) {
    await http.delete(`${this.baseUrl}/${dto.id}`)
  }
}

export default new UserService()
